import { NavigationTabs } from "@/components/ui/navigation-tabs";
import { PageWithTitle } from "@common/components/PageLayout/PageWithTitle";
import { PeopleTab } from "./people/PeopleTab";
import { DepartmentsTab } from "./departments/DepartmentsTab";
import { CategoriesTab } from "./categories/CategoriesTab";
import { useRecoilValue } from "recoil";
import { roleState } from "@common/state/roleState";
import { useMemo } from "react";
import { UserRole } from "@common/utils/graphql";
import { BankAccountTab } from "./bank-account/employee/BankAccountTab";
import { AdminBankAccountTab } from "./bank-account/admin/AdminBankAccountTab";
import { SettingsSelectedTab } from "./constants";
import { ProfileTab } from "./profile/employee/ProfileTab";
import { CustomFieldsTab } from "./custom-fields";

const renderTab = (tab: SettingsSelectedTab, role: UserRole) => {
  switch (tab) {
    case SettingsSelectedTab.People:
      return <PeopleTab />;
    case SettingsSelectedTab.Departments:
      return <DepartmentsTab />;
    case SettingsSelectedTab.Categories:
      return <CategoriesTab />;
    case SettingsSelectedTab.Profile:
      return <ProfileTab />;
    case SettingsSelectedTab.BankAccount:
      return role === UserRole.Admin ? (
        <AdminBankAccountTab />
      ) : (
        <BankAccountTab />
      );
    case SettingsSelectedTab.CustomFields:
      return <CustomFieldsTab />;
    default:
      return null;
  }
};
interface Props {
  tab: SettingsSelectedTab;
}

export const SettingsPage = ({ tab }: Props) => {
  const role = useRecoilValue(roleState);

  const tabs = useMemo(() => {
    const tabs = [
      {
        id: SettingsSelectedTab.Profile,
        name: SettingsSelectedTab.Profile.toString(),
        route: `/settings/profile`,
        access: [UserRole.Employee],
      },
      {
        id: SettingsSelectedTab.People,
        name:
          role === UserRole.Manager
            ? "Your Team"
            : SettingsSelectedTab.People.toString(),
        route: `/${role}/settings/people`,
        access: [UserRole.Admin, UserRole.Manager],
      },
      {
        id: SettingsSelectedTab.Departments,
        name: SettingsSelectedTab.Departments.toString(),
        route: `/${role}/settings/departments`,
        access: [UserRole.Admin],
      },
      {
        id: SettingsSelectedTab.Categories,
        name: SettingsSelectedTab.Categories.toString(),
        route: `/${role}/settings/categories`,
        access: [UserRole.Admin],
      },
      {
        id: SettingsSelectedTab.CustomFields,
        name: SettingsSelectedTab.CustomFields,
        route: `/${role}/settings/custom-fields`,
        access: [UserRole.Admin],
      },
      {
        id: SettingsSelectedTab.BankAccount,
        name: SettingsSelectedTab.BankAccount.toString(),
        route: `/settings/bank-account`,
        access: [UserRole.Admin, UserRole.Employee],
      },
    ];
    return tabs;
  }, [role]);

  return (
    <PageWithTitle title="Settings">
      <NavigationTabs
        tabs={tabs.filter((t) => t.access.includes(role))}
        selectedTab={tab}
      />
      {renderTab(tab, role)}
    </PageWithTitle>
  );
};
